import { render, staticRenderFns } from "./NeoparentLexicon.vue?vue&type=template&id=4bbea2b2&scoped=true"
import script from "./NeoparentLexicon.vue?vue&type=script&lang=js"
export * from "./NeoparentLexicon.vue?vue&type=script&lang=js"
import style0 from "./NeoparentLexicon.vue?vue&type=style&index=0&id=4bbea2b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbea2b2",
  null
  
)

export default component.exports